import { render, staticRenderFns } from "./GroupSales.vue?vue&type=template&id=f3343608&scoped=true&"
import script from "./GroupSales.vue?vue&type=script&lang=js&"
export * from "./GroupSales.vue?vue&type=script&lang=js&"
import style0 from "./GroupSales.vue?vue&type=style&index=0&id=f3343608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3343608",
  null
  
)

export default component.exports